import React, { Suspense, useState } from 'react'
import { Skeleton, Typography, Button, Row } from 'antd'

import { MarketIndexesList } from './MarketIndexesList/MarketIndexesList'
import { MarketIndexCreateDrawer } from './MarketIndexCreate'
import useSWR from 'swr'
import { buildMarketTableSource, MarketIndex } from './models'
import { fetchDetail } from '../../api'

const MarketIndexesContent = () => {
  const [isCreateDrawerOpen, setIsCreateDrawerOpen] = useState(false)

  const { data, mutate } = useSWR<MarketIndex[]>('/market-indexes', fetchDetail, { suspense: true })
  const marketIndexes = data ? data.map(buildMarketTableSource) : []

  return (
    <>
      <Row justify="space-between">
        <Typography.Title>Market Indexes</Typography.Title>
        <Button type="primary" size="large" onClick={() => setIsCreateDrawerOpen(true)}>
          Create new market index
        </Button>
      </Row>

      <MarketIndexesList isLoading={data === null} marketIndexes={marketIndexes} fetchMarketIndexes={mutate} />
      <MarketIndexCreateDrawer
        isVisible={isCreateDrawerOpen}
        onClose={() => setIsCreateDrawerOpen(false)}
        onSuccess={() => {
          mutate()
          setIsCreateDrawerOpen(false)
        }}
      />
    </>
  )
}

export const MarketIndexesPage = ({ children }) => (
  <Suspense fallback={<Skeleton />}>
    <MarketIndexesContent />
  </Suspense>
)
